/**
 * Bring the first validation error into view so phone users can see what to fix,
 * even when it sits far above the fixed Next/Save buttons.
 *
 * Scrolls the first invalid field (or standalone error message) to the middle of
 * the screen, focuses it when it is a form field, and optionally repeats the
 * message in a toast at the top of the screen.
 *
 * Call it after Vue has re-rendered the error classes (i.e. inside $nextTick).
 *
 * @param {Element} root
 * @param {{ swal?: Function }} [options]
 * @returns {string|null} the error message shown, or null when nothing is invalid
 */
export default function focusFirstError(root, { swal } = {}) {
    const target = root ? root.querySelector('.is-invalid, .invalid-feedback.d-block') : null;

    if (!target) {
        return null;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName)) {
        target.focus({ preventScroll: true });
    }

    const message = messageFor(target) || 'Please fill in the highlighted field';

    if (swal) {
        swal({
            toast: true,
            position: 'top',
            icon: 'warning',
            title: message,
            showConfirmButton: false,
            timer: 3000,
        });
    }

    return message;
}

function messageFor(target) {
    if (target.classList.contains('invalid-feedback')) {
        return target.textContent.trim();
    }

    const group = target.closest('.form-group');
    const feedback = group ? group.querySelector('.invalid-feedback') : null;

    return feedback ? feedback.textContent.trim() : null;
}
